import React from "react";
import { CreateApolloClient } from "src/lib/ApolloClient";
import { AppSupplier } from "./AppSupplier";
import { useToken } from "src/components/authentication/TokenProvider";
import { ApolloProvider } from "@apollo/client";

export function AppContent() {
  const { token } = useToken();

  return (
    <ApolloProvider client={CreateApolloClient(token || "")}>
      <AppSupplier />
    </ApolloProvider>
  );
}
